import React, { useMemo } from "react";
import { useI18n } from "Hooks";

import { Button } from "@toddle-edu/ds-web";
import { TickCircleOutlined, CloseCircleOutlined } from "@toddle-edu/ds-icons";

const DeadlineComplete = props => {
  const {
    isDeadlineComplete,
    onUpdateProjectDeadline,
    projectTaskId,
    isUploadInProgress,
    testId,
  } = props;

  const { t } = useI18n(["project"]);

  const {
    iconVariant: deadlineButtonIconVariant,
    buttonLabel: deadlineButtonLabel,
    buttonType: deadlineButtonType,
    buttonIcon: deadlineIcon,
  } = useMemo(() => {
    if (!isDeadlineComplete) {
      return {
        iconVariant: "progressive",
        buttonType: "fill",
        buttonLabel: t("project:mark_as_complete"),
        buttonIcon: <TickCircleOutlined />,
      };
    } else {
      return {
        iconVariant: "neutral",
        buttonType: "outlined",
        buttonLabel: t("project:mark_as_pending"),
        buttonIcon: <CloseCircleOutlined />,
      };
    }
  }, [isDeadlineComplete]);

  return (
    <Button
      dsVersion="2.0"
      variant={deadlineButtonIconVariant}
      type={deadlineButtonType}
      icon={deadlineIcon}
      disabled={isUploadInProgress}
      onClick={() => {
        onUpdateProjectDeadline({
          input: {
            deadlineIds: [projectTaskId],
            isComplete: !isDeadlineComplete,
          },
        });
      }}
      testId={`${testId}-deadline-complete-button`}
    >
      {deadlineButtonLabel}
    </Button>
  );
};

export default DeadlineComplete;
